// src/components/App/NavBar.js

import React, { PureComponent } from "react";
import ReactTooltip from "react-tooltip";
import "./NavBar.css";

class NavBar extends PureComponent {
  constructor(props) {
    super(props);

    const gpNotAllowed = [
      "my-portfolio-hub",
      "models",
      "portfolio-analysis",
      "capital-gains-comparison",
      "custom-models",
    ];
    let toolsToShow = props.toolsToShow;
    if (!props.isFP) {
      toolsToShow = toolsToShow.filter(function (value) {
        return !gpNotAllowed.includes(value);
      });
    }
    toolsToShow.unshift("");

    this.state = {
      toolsToShow: toolsToShow,
    };
  }

  barStyle = {
    height: "50px",
  };

  buttonStyle = {
    width: this.props.isFP ? 100 / 14 + "%" : 100 / 10 + "%",
    backgroundColor: "#FFF",
    color: "#07003c",
    borderBottom: "1px solid #FFFFFF",
    display: "inline-block",
    height: "50px",
    fontSize: "24px",
    lineHeight: "24px",
    textAlign: "center",
    paddingTop: "12px",
    cursor: "pointer",
  };

  buttonStyleOn = {
    width: this.props.isFP ? 100 / 14 + "%" : 100 / 10 + "%",
    backgroundColor: "transparent",
    color: "#07003c",
    borderBottom: "1px solid #FFFFFF",
    display: "inline-block",
    height: "50px",
    fontSize: "24px",
    lineHeight: "24px",
    textAlign: "center",
    paddingTop: "12px",
    cursor: "pointer",
  };

  getIconStyle(name, activeApp) {
    if (name === activeApp) {
      return name;
    } else if (name === "") {
      return "home-off";
    } else {
      return `${name}-off`;
    }
  }

  renderButton() {
    const { activeApp, selectCallback } = this.props;

    const { toolsToShow } = this.state;
    const buttonCount = toolsToShow.length || 1;
    const widthStyle = { width: `${100 / buttonCount}%` };

    let names = toolsToShow;
    if (activeApp === "") {
      names = [];
    }

    const tooltips = {
      myportfoliohub: "My Portfolio Hub",
      portfolioanalysis: "Portfolio Analysis",
      custommodels: "Custom Model Portfolio Builder",
      fundcomparison: "Fund Comparison",
      capitalgainscomparison: "Capital Gains Comparison",
      indexattribution: "Index Attribution",
      fundattribution: "Fund Attribution",
      performanceataglance: "Performance at a Glance",
      morningstarratings: "Morningstar Ratings",
      fibb: "Fixed Income Barbell",
      capitalefficiency: "Capital Efficient Portfolio Studio",
      earnings: "Earnings Path",
      chartaday: "Daily Charts",
      models: "Model Portfolios",
      modelperformance: "Model Portfolios",
    };

    return names.map((name) => {
      const nameId = name.replace(/-/g, "");
      return (
        <div
          key={name}
          data-tip
          data-for={name + "-desc"}
          style={{
            ...(activeApp === name ? this.buttonStyleOn : this.buttonStyle),
            ...widthStyle,
          }}
          role="button"
          tabIndex={0}
          aria-label={tooltips[nameId] ? tooltips[nameId] : "Home"}
          onClick={() => selectCallback(name)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              selectCallback(name);
            }
          }}
        >
          <div
            className={this.getIconStyle(name, activeApp)}
            aria-hidden="true"
          >
            &nbsp;
          </div>
          <ReactTooltip
            id={name + "-desc"}
            type="light"
            className="plat-tooltip"
            effect="float"
          >
            {tooltips[nameId] ? tooltips[nameId] : "Home"}
          </ReactTooltip>
        </div>
      );
    });
  }

  render() {
    const { activeApp } = this.props;

    if (activeApp !== "") {
      return <div style={this.barStyle}>{this.renderButton()}</div>;
    } else {
      return null;
    }
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/App/NavBar.js